import { AUTH_INFO } from './../actions/types'

export default (state = {}, { type, payload }) => {
    switch(type) {
        case AUTH_INFO:
            return payload
        default:
            return state
    }
}